import { GhostIconButton, Space, Text, mq } from "@certn/cascadia-react";
import { css, keyframes } from "@emotion/css";
import { PropsWithChildren } from "react";

interface ActionToastProps extends PropsWithChildren {
  isOpen: boolean;
  onDismiss: () => void;
  label: string;
  maxWidth?: string;
}

export function ActionToast(props: ActionToastProps) {
  const { isOpen, onDismiss, children, maxWidth, label } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div
        role="region"
        aria-label={label}
        className={css(styles.toast, { maxWidth: maxWidth || "480px" })}
      >
        <GhostIconButton
          aria-label="close-action-toast"
          color="icon-inverse"
          size="small"
          icon="close"
          onPress={onDismiss}
        />
        <Text style="global/modal-header-small" color="text-inverse">
          {label}
        </Text>
        <Space />
        {children}
      </div>
    </div>
  );
}

const slide = keyframes`
  from {
    transform: translateY(8px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const styles = {
  overlay: css(
    {
      display: "flex",
      justifyContent: "center",
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 100,
      pointerEvents: "none",
    },
    mq({
      padding: ["var(--space-4)", "var(--space-8)"],
    })
  ),
  toast: css({
    display: "flex",
    backgroundColor: "var(--background-inverse)",
    color: "var(--text-inverse)",
    borderRadius: "var(--border-radius-2)",
    alignItems: "center",
    boxShadow: "var(--shadow-modal)",
    boxSizing: "border-box",
    flexDirection: "row",
    flexGrow: 1,
    gap: "var(--space-2)",
    outline: "none",
    padding: "var(--space-4)",
    pointerEvents: "auto",
    animation: `${slide} 100ms`,
  }),
};
